import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("video3", component(opts));
  editor.BlockManager.add("video3", block(opts));
};